<template>
	<div>
		<!-- eslint-disable-next-line vue/no-mutating-props -->
		<v-dialog
			v-if="locationDialog"
			v-model="locationDialog"
			:max-width="popupWidth"
			style="margin: 0"
			height="96vh"
			persistent>
			<div
				class="location-dialog"
				:class="`${theme}-theme`"
				@click="actions.cancelEvent"
				@dblclick="actions.cancelEvent($event)">
				<div class="popup pa-0" :class="isMobile && 'overflow-auto'">
					<div class="popup-header pa-0 text-center">
						<div class="text-right pa-1">
							<v-btn class="close-icon" small icon @click="actions.close()">
								<v-icon size="18">{{ icons.mdiClose }}</v-icon>
							</v-btn>
						</div>
						<h4 class="fs--24 fw--600 popup-header-text">Pick a Location</h4>
					</div>
					<div class="popup-body">
						<div class="popup-content pa-0">
							<!-- <p v-if="size === 'sm'" class="fw--600 fs--12 white--text mb-2 text-center">
								Pick any location on stream <br />
								to place this sticker!
							</p>
							<p v-else class="fw--600 fs--12 white--text mb-2 text-center">
								Pick any location on stream to place this sticker!
							</p> -->
							<div
								v-if="isMobile"
								class="stream-view"
								id="streamView"
								@click="actions.locateImage($event)"
								:style="{
									'background-image': `url('${streamThumb}')`,
									'background-size': '100% 100%',
									'background-color': isRandomPlacement ? 'rgba(0,0,0,0.65)' : 'rgba(0,0,0,0)',
									'background-blend-mode': 'overlay',
									height: streamBox.height,
									width: streamBox.width,
								}">
								<div
									v-if="isLoading"
									class="loading-overlay d-flex flex-column justify-center align-center">
									<v-progress-circular
										color="primary"
										style="width: 3rem; height: 3rem"
										class="mb-1"
										indeterminate></v-progress-circular>
									<span class="white--text fs--14 fw--700">Slapping Sticker on Stream...</span>
								</div>
								<div
									v-if="boundingBox.width > 0"
									id="stickerImage"
									:class="!isRandomPlacement && 'sticker_border'"
									:style="{
										width: boundingBox.width + 'px',
										height: boundingBox.height + 'px',
										display: 'flex',
										flexDirection: 'column',
										alignItems: 'center',
										justifyContent: 'center',
									}">
									<div
										class="icons"
										:style="{
											height: boundingBox.height + 'px',
											width: boundingBox.width + 'px',
										}">
										<template v-if="!isRandomPlacement">
											<v-icon
												size="30"
												class="rotate-icon"
												id="rotateIcon"
												color="white"
												@click.stop="actions.rotate"
												>{{ icons.rotate }}</v-icon
											>
											<img
												@click.stop="actions.flipSticker"
												width="30"
												height="30"
												src="@/assets/icons/flip_icon.png"
												alt="Flip"
												id="flipIconMobile"
												class="flip-mobile-icon" />
										</template>
									</div>
									<div id="sticker">
										<template v-if="sticker.stickerType === 'TTS'">
											<AssetsTTS
												:sticker="sticker"
												:width="stickerDimensions.baseWidth"
												:height="stickerDimensions.baseHeight"
												:percent="stickerDimensions.assetPercentage"
												:list="false"
												:fade="isRandomPlacement"
												:popupMd="true" />
										</template>
										<template v-else>
											<div
												:style="{
													width: `${stickerDimensions.baseWidth}px`,
													height: `${stickerDimensions.baseHeight}px`,
													opacity: `${isRandomPlacement ? 0.5 : 1}`,
												}">
												<img
													id="normalImage"
													:src="
														sticker.rendererImage
															? getStickerRendererImagePath(sticker)
															: getStickerImagePath(sticker)
													"
													width="100%"
													height="auto"
													:alt="sticker.name" />
											</div>
											<!-- <v-img
												:src="getStickerImagePath(sticker)"
												:width="stickerDimensions.baseWidth"
												:height="stickerDimensions.baseHeight"
												contain></v-img> -->
										</template>
									</div>
								</div>
							</div>
							<div
								v-else
								class="stream-view"
								id="streamView"
								v-click-outside="(isActive = false)"
								@click="actions.setActive()"
								:style="{
									'background-image': `url('${streamThumb}')`,
									'background-size': '100% 100%',
									'background-color': isRandomPlacement ? 'rgba(0,0,0,0.65)' : 'rgba(0,0,0,0)',
									'background-blend-mode': 'overlay',
									height: streamBox.height,
									width: streamBox.width,
								}">
								<div
									v-if="isLoading"
									class="loading-overlay d-flex flex-column justify-center align-center">
									<v-progress-circular
										color="primary"
										style="width: 3rem; height: 3rem"
										class="mb-1"
										indeterminate></v-progress-circular>
									<span class="white--text fs--14 fw--700">Slapping Sticker on Stream...</span>
								</div>
								<VueDrr
									v-if="boundingBox.width > 0"
									id="stickerddr"
									class="sticker-ddr"
									:class="isRandomPlacement ? 'disabled-ddr' : 'sticker_border'"
									:parent="true"
									:w="boundingBox.width + 5"
									:h="boundingBox.height + 5"
									:x="placement.x"
									:y="placement.y"
									:angle="placement.angle"
									:selected="isRandomPlacement ? false : true"
									:draggable="!isRandomPlacement && true"
									:resizable="!isRandomPlacement && true"
									:rotatable="!isRandomPlacement && true"
									:aspectRatio="true"
									:isFlipped="isFlipped"
									:outerBound="outerBounds"
									@rotatestart="actions.setPlacement"
									@rotate="actions.setPlacement"
									@rotatestop="actions.setPlacement"
									:style="{
										display: 'flex',
										flexDirection: 'column',
										alignItems: 'center',
										justifyContent: 'center',
									}">
									<div id="stickerImag">
										<div id="sticker">
											<template v-if="sticker.stickerType === 'TTS'">
												<AssetsTTS
													:sticker="sticker"
													:width="stickerDimensions.baseWidth"
													:height="stickerDimensions.baseHeight"
													:percent="stickerDimensions.assetPercentage"
													:percentX="stickerDimensions.assetPercentageX"
													:percentY="stickerDimensions.assetPercentageY"
													:fade="isRandomPlacement"
													:list="false"
													:popupMd="true" />
											</template>
											<template v-else>
												<div
													:style="{
														width: `${stickerDimensions.baseWidth}px`,
														height: `${stickerDimensions.baseHeight}px`,
														opacity: `${isRandomPlacement ? 0.5 : 1}`,
													}">
													<img
														id="normalImage"
														:src="
															sticker.rendererImage
																? getStickerRendererImagePath(sticker)
																: getStickerImagePath(sticker)
														"
														width="100%"
														height="auto"
														:alt="sticker.name" />
												</div>
												<!-- <v-img
													:src="getStickerImagePath(sticker)"
													:width="stickerDimensions.baseWidth"
													:height="stickerDimensions.baseHeight"
													></v-img> -->
											</template>
											<!-- <v-icon v-if="!isRandomPlacement" size="18" class="rotate-icon" color="white"
												@click.stop="actions.rotate">{{ icons.rotate }}</v-icon> -->
										</div>
									</div>
									<img
										v-if="!isRandomPlacement"
										@click="actions.flipSticker"
										width="25"
										height="25"
										src="@/assets/icons/flip_icon.png"
										alt="Flip"
										id="flipIconPanel"
										class="flip-panel-icon" />
								</VueDrr>
							</div>
							<div class="primary d-flex justify-center">
								<span class="fs--11 white--text fw--600 py-1">
									{{
										isRandomPlacement
											? 'Random Placement Enabled'
											: isMobile
											? 'Tap to move position, rotate and flip'
											: 'Drag to move position, rotate and tap to flip'
									}}
								</span>
							</div>

							<div class="px-2 pb-2">
								<v-btn
									v-if="!isBroadcaster"
									color="primary"
									class="fs--13 fw--600 mt-3 mb-2 py-6 text-center text-uppercase slap-btn"
									@click="actions.useSticker()">
									<div class="d-flex flex-column">
										<span class="fs--13">slap sticker on stream!</span>
										<div class="d-flex align-center justify-center">
											<img :src="actions.getIcon(bitsValue)" width="15" alt="Bits" />
											<span class="fs--13">{{ bitsValue }}</span>
										</div>
									</div>
								</v-btn>
								<v-btn
									v-else
									color="primary"
									class="fs--13 fw--600 mt-3 mb-2 py-6 text-center text-uppercase slap-btn"
									@click="actions.useSticker()">
									<div class="d-flex flex-column">
										<span class="fs--13">slap sticker on stream!</span>
									</div>
								</v-btn>

								<div class="d-flex align-center justify-center">
									<v-switch
										v-model="isRandomPlacement"
										@change="actions.setRandomPlacement"
										color="primary"
										class="ma-0"
										hide-details>
										<template #label>
											<span class="fs--14 fw--600 white--text">Enable Random Placement</span>
										</template>
									</v-switch>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</v-dialog>
	</div>
</template>

<script>
import { useStore } from '@/store';
import { computed, reactive, ref, onMounted } from 'vue';
import { getStickerImagePath, getStickerRendererImagePath } from '@/utils/utils';
import { mdiClose, mdiRotateRight } from '@mdi/js';
import { getBitIcon } from '@/utils/utils';
import { getEndpointHost, getHostedAssetPath } from '@/utils/config';
import AssetsTTS from '@/components/panel/Stickers/AssetsTTS.vue';
import VueDrr from '@/components/panel/VueDrr.vue';
export default {
	components: {
		VueDrr,
		AssetsTTS,
	},
	props: {
		locationDialog: {
			type: Boolean,
			default: false,
		},
		isBroadcaster: {
			type: Boolean,
			default: false,
		},
		sticker: Object,
	},
	emits: ['onUseSticker', 'onClose'],
	setup(props, ctx) {
		const store = useStore();

		const theme = computed(() => store.state.theme);
		const size = computed(() => store.state.size);
		const isMobile = computed(() => {
			return store.state.isMobile;
		});

		const isLoading = ref(false);
		const isImageLoaded = ref(false);
		const popupWidth = ref('95%');

		const streamHeight = ref(197);

		const streamBox = computed(() => {
			let width, height;

			if (size.value === 'md' && !isMobile.value) {
				width = '506px';
				height = '285px';
			}

			if (size.value === 'sm' && !isMobile.value) {
				width = '296px';
				height = '167px';
			}

			if (isMobile.value) {
				width = '100%';
				height = `${streamHeight.value}px`;
			}

			return { width, height };
		});

		const isRandomPlacement = ref(false);
		const isFlipped = ref(false);

		const isActive = ref(false);

		const baseHeight = ref(0);
		const baseWidth = ref(0);

		const percentX = ref(0);
		const percentY = ref(0);

		const placement = reactive({
			x: 125.5,
			y: 62.5,
			angle: 0,
		});

		const oldPlacement = reactive({
			x: 0,
			y: 0,
			angle: 0,
			flipped: false,
		});

		const outerBounds = reactive({
			x: 100,
			y: 61,
			w: 226,
			h: 125,
		});

		const boundingBox = reactive({
			width: 0,
			height: 0,
		});

		onMounted(() => {
			actions.setPopupWidth();

			if (isMobile.value) {
				const box = document.querySelector('.popup-content');
				if (box) {
					const boxWidth = box.offsetWidth;
					streamHeight.value = (9 * boxWidth) / 16;
				}
			}

			const random = localStorage.getItem('isRandomPlacement');
			isRandomPlacement.value = random == 1 ? true : false;

			placement.x = document.querySelector('#streamView').offsetWidth / 2;
			placement.y = document.querySelector('#streamView').offsetHeight / 2;

			if (!props.sticker.tts) {
				const img = new Image();
				img.src = props.sticker.rendererImage
					? getStickerRendererImagePath(props.sticker)
					: getStickerImagePath(props.sticker);
				img.onload = () => {
					isImageLoaded.value = true;
					const { width, height } = actions.getImageDimensions(img.width, img.height);
					baseWidth.value = width;
					baseHeight.value = height;

					actions.setBoundingBounds();
					setTimeout(() => {
						actions.setFlipIconPosition();
					}, 10);
				};
			} else {
				// TTS Sticker
				const img = new Image();
				img.src = getHostedAssetPath() + '/' + props.sticker.tts.baseImage;
				img.onload = () => {
					isImageLoaded.value = true;
					const { width, height } = actions.getImageDimensions(img.width, img.height);

					baseWidth.value = width;
					baseHeight.value = height;

					// For TTS Assets Size Calculations
					percentX.value = (width / 250) * 100;
					percentY.value = (height / 300) * 100;

					actions.setBoundingBounds();

					setTimeout(() => {
						actions.setFlipIconPosition();
					}, 10);
				};
			}

			actions.setOuterBounds();

			if (isRandomPlacement.value) {
				actions.centerImage();
			}
		});

		const stickerDimensions = computed(() => {
			const dimensions = {
				baseWidth: baseWidth.value,
				baseHeight: baseHeight.value,
				assetPercentage: 32,
				assetPercentageX: percentX.value,
				assetPercentageY: percentY.value,
			};

			// if (size.value === 'md') {
			// 	dimensions.baseWidth = 83.25;
			// 	dimensions.baseHeight = 100;
			// 	dimensions.assetPercentage = 33.3;
			// }

			return dimensions;
		});

		const bitsValue = computed(() => {
			if (props.sticker.bits && props.sticker.bits !== 0) {
				return props.sticker.bits
					? props.sticker.bits.toLocaleString()
					: Number(props.sticker.sku.split('_')[1]).toLocaleString();
			}
			return 0;
		});

		// Stream thumbnail. The host needs the 8081 port as that is how the extension allowed list is configured on Twitch.
		const streamThumb = computed(() => {
			const loginName = store.state.streamerDisplayName.toLowerCase();
			let host = getEndpointHost();
			if (host == 'extension-dev.streamstickers.com' || host == 'extension.streamstickers.com') {
				host += ':8081';
			}
			return 'https://' + host + '/panel/stream-thumb/' + loginName + '/' + Date.now();
		});

		const actions = {
			setPopupWidth() {
				const width = isMobile.value ? '95%' : size.value === 'sm' && !isMobile.value ? 300 : 510;
				popupWidth.value = width;

				const dialog = document.querySelector('.v-dialog');
				dialog.style.margin = 0;
			},
			getImageDimensions(width, height) {
				let imWidth = width;
				let imHeight = height;

				if (props.sticker.tts) {
					// MAX TTS will displayed as 350x350 in Renderer
					if (width > 350 || height > 350) {
						imWidth = 350;
						imHeight = 350;
					}
				}

				// Renderer Width and Height
				const rendererW = 1920;
				const rendererH = 1080;

				// Stream Box Width and Height
				const stream = document.getElementById('streamView');
				const streamW = stream.offsetWidth;
				const streamH = stream.offsetHeight;

				// Stream Difference
				const scaledWidth = parseFloat((streamW / rendererW) * 100).toFixed(1);
				const scaledHeight = parseFloat((streamH / rendererH) * 100).toFixed(1);

				const scaledImgW = parseFloat((imWidth / 100) * scaledWidth).toFixed(1);
				const scaledImgH = parseFloat((imHeight / 100) * scaledHeight).toFixed(1);

				return {
					width: scaledImgW * 1,
					height: scaledImgH * 1,
				};
			},
			setBoundingBounds() {
				const width = stickerDimensions.value.baseWidth;
				const height = stickerDimensions.value.baseHeight;

				let size = 26;

				if (width > height) {
					boundingBox.height = width + (width / 100) * size;
					boundingBox.width = width + (width / 100) * size;
				} else {
					boundingBox.height = height + (height / 100) * size;
					boundingBox.width = height + (height / 100) * size;
				}
			},
			setOuterBounds() {
				const stream = document.querySelector('#streamView');
				outerBounds.w = stream.offsetWidth + 40;
				outerBounds.h = stream.offsetHeight + 40;
				outerBounds.x = stream.offsetWidth / 2;
				outerBounds.y = stream.offsetHeight / 2;
			},
			setRandomPlacement(val) {
				localStorage.setItem('isRandomPlacement', val ? 1 : 0);
				if (val) {
					actions.getImageOldPositions();
					actions.centerImage();
				} else {
					actions.setImageOldPositions();
				}
			},
			getImageOldPositions() {
				let sticker;

				if (!isMobile.value) {
					sticker = document.querySelector('#stickerddr');
				} else {
					sticker = document.querySelector('#stickerImage');
				}

				const left = window.getComputedStyle(sticker).left;
				const top = window.getComputedStyle(sticker).top;

				oldPlacement.x = left;
				oldPlacement.y = top;
			},
			setImageOldPositions() {
				let sticker;

				if (!isMobile.value) {
					sticker = document.querySelector('#stickerddr');
				} else {
					sticker = document.querySelector('#stickerImage');
				}

				sticker.style.left = oldPlacement.x;
				sticker.style.top = oldPlacement.y;

				isFlipped.value = oldPlacement.flipped;
				placement.angle = oldPlacement.angle;

				if (isMobile.value) {
					const stickerImage = document.getElementById('sticker');

					stickerImage.style.transform = oldPlacement.flipped
						? `rotate(${oldPlacement.angle}deg) scaleX(-1)`
						: `rotate(${oldPlacement.angle}deg) scaleX(1)`;
				} else {
					sticker.style.transform = oldPlacement.flipped
						? `rotate(${oldPlacement.angle}deg) scaleX(-1)`
						: `rotate(${oldPlacement.angle}deg) scaleX(1)`;
				}
			},
			centerImage() {
				oldPlacement.angle = placement.angle;
				oldPlacement.flipped = isFlipped.value;

				const stream = document.querySelector('#streamView');
				let sticker;

				if (!isMobile.value) {
					sticker = document.querySelector('#stickerddr');
				} else {
					sticker = document.querySelector('#stickerImage');
				}

				actions.getImageOldPositions();

				placement.angle = 0;
				isFlipped.value = false;

				const center = {
					x: stream.offsetWidth / 2,
					y: stream.offsetHeight / 2,
				};

				placement.x = Number(center.x);
				placement.y = Number(center.y);

				if (isMobile.value) {
					sticker.style.left = '50%';
					sticker.style.top = '50%';

					const stickerImage = document.getElementById('sticker');
					stickerImage.style.transform = `rotate(${placement.angle}deg) scaleX(1)`;
				} else {
					sticker.style.left = placement.x - sticker.offsetWidth / 2 + 'px';
					sticker.style.top = placement.y - sticker.offsetHeight / 2 + 'px';
					sticker.style.transform = `rotate(${placement.angle}deg) scaleX(1)`;
				}
			},
			locateImage(event) {
				const sticker = document.querySelector('#stickerImage');
				const stream = document.querySelector('#streamView');
				if (!isRandomPlacement.value && event) {
					const x = event.clientX - stream.getBoundingClientRect().left;
					const y = event.clientY - stream.getBoundingClientRect().top;

					sticker.style.left = x + 'px';
					sticker.style.top = y + 'px';
				}
			},

			rotate(value) {
				if (!isRandomPlacement.value) {
					let rotationAngle = placement.angle;

					if (value !== null && value >= 0) {
						rotationAngle = 0;
					} else {
						rotationAngle = rotationAngle + 45;
					}

					if (rotationAngle >= 360) {
						rotationAngle = 0;
					}

					placement.angle = rotationAngle;
					actions.transformSticker();
				}
			},

			flipSticker() {
				isFlipped.value = !isFlipped.value;

				if (isMobile.value) {
					const stickerImg = document.getElementById('stickerImage');

					const rotateIcon = document.getElementById('rotateIcon');
					const flipIcon = document.getElementById('flipIconMobile');

					if (isFlipped.value) {
						rotateIcon.style.transform = 'scaleX(-1)';
						flipIcon.style.transform = 'scaleX(-1)';
					} else {
						rotateIcon.style.transform = 'scaleX(1)';
						flipIcon.style.transform = 'scaleX(1)';
					}
				} else {
					const flipIcon = document.getElementById('flipIconPanel');
					if (isFlipped.value) {
						flipIcon.style.transform = 'scaleX(-1)';
					} else {
						flipIcon.style.transform = 'scaleX(1)';
					}
				}

				actions.setFlipIconPosition();
				actions.transformSticker();
			},

			setFlipIconPosition() {
				let flipIcon, stickerImg, pos;
				if (isMobile.value) {
					stickerImg = document.getElementById('stickerImage');
					flipIcon = document.getElementById('flipIconMobile');

					if (!flipIcon) {
						return;
					}

					const flipW = flipIcon.clientWidth;
					pos = (stickerImg.offsetWidth - flipW) / 2;
				} else {
					stickerImg = document.querySelector('#stickerddr');
					flipIcon = document.querySelector('#flipIconPanel');

					if (!flipIcon) {
						return;
					}
					const flipW = flipIcon.clientWidth;
					pos = (stickerImg.offsetWidth - flipW) / 2;
				}

				if (isFlipped.value) {
					flipIcon.style.left = 'unset';
					flipIcon.style.right = pos + 'px';
					flipIcon.style.transform = 'scaleX(-1)';
				} else {
					flipIcon.style.right = 'unset';
					flipIcon.style.left = pos + 'px';
					flipIcon.style.transform = 'scaleX(1)';
				}

				flipIcon.style.bottom = '-28px';
			},

			transformSticker() {
				let sticker = document.querySelector('#sticker');
				if (!isMobile.value) {
					sticker = document.querySelector('#stickerddr');
					sticker.style.transform = isFlipped.value
						? `rotate(${placement.angle}deg) scaleX(-1)`
						: `rotate(${placement.angle}deg) scaleX(1)`;

					return;
				}

				sticker.style.transform = isFlipped.value
					? `rotate(${placement.angle}deg) scaleX(-1)`
					: `rotate(${placement.angle}deg) scaleX(1)`;
			},

			close() {
				ctx.emit('onClose');
			},

			getIcon(value) {
				let bits = value;
				if (typeof bits === 'string') {
					bits = Number(bits.replaceAll(',', ''));
				}

				return getBitIcon(bits);
			},

			cancelEvent(event) {
				event.stopImmediatePropagation();
			},

			setActive() {
				isActive.value = true;
				if (isRandomPlacement.value) {
					isActive.value = false;
				}
			},

			setPlacement(dimension) {
				const sticker = document.querySelector('#stickerddr');
				// placement.x = dimension.x;
				// placement.y = dimension.y;
				placement.angle = dimension.angle;
				actions.setOuterBounds();
				// sticker.style.transform = isFlipped.value
				// 	? `rotate(${placement.angle}deg) scaleX(-1)`
				// 	: `rotate(${placement.angle}deg) scaleX(1)`;
			},

			useSticker() {
				if (isLoading.value || !isImageLoaded.value) {
					return;
				}

				// Set Angle 0 to reset the sticker positions after rotation
				const angle = placement.angle;
				if (placement.angle > 0 || placement.angle < 0) {
					placement.angle = 0;
				}

				let slap;
				isLoading.value = true;

				setTimeout(() => {
					slap = actions.calculatePlacement();
					let image;
					if (!props.sticker.tts) {
						image = document.getElementById('normalImage');
						slap.h = image.height;
						slap.w = image.width;
					}

					// Reset Angle
					placement.angle = angle;
					slap.a = angle;

					isLoading.value = false;

					ctx.emit('onUseSticker', slap);
					actions.close();
				}, 500);
			},

			calculatePlacement() {
				const sticker = document.querySelector('#sticker');
				const stream = document.querySelector('#streamView');

				const stickerRect = sticker.getBoundingClientRect();
				const streamRect = stream.getBoundingClientRect();

				const height = stickerRect.height;
				const width = stickerRect.width;

				const left = stickerRect.left - streamRect.left;
				const top = stickerRect.top - streamRect.top;

				const bottom = streamRect.bottom - stickerRect.bottom;
				const right = streamRect.right - stickerRect.right;

				const slap = {
					left: left, // Distance in px from Left
					top: top, // Distance in px from Top
					bottom: bottom, // Distance in px from Bottom
					right: right, // Distance in px from Right
					w: width, // Sticker Width in px for this action
					h: height, // Sticker Height in px for this action
					boxWidth: streamRect.width, // Box Width
					boxHeight: streamRect.height, // Box Width
					a: placement.angle, // Sticker Rotation Angle
					isFlipped: isFlipped.value, // Sticker is Flipped or not
					isRandomPlacement: isRandomPlacement.value, // Sticker Random Placement is enabled or not
				};

				return slap;
			},
		};

		return {
			isLoading,
			theme,
			size,
			isMobile,
			popupWidth,
			streamBox,
			isRandomPlacement,
			stickerDimensions,
			isActive,
			placement,
			bitsValue,
			outerBounds,
			boundingBox,
			isFlipped,

			streamThumb,

			actions,

			getStickerImagePath,
			getStickerRendererImagePath,
			icons: {
				rotate: mdiRotateRight,
				mdiClose,
			},
		};
	},
};
</script>

<style lang="scss" scoped>
.popup-header {
	position: relative;
	height: auto !important;
	padding: 12px !important;
}

.close-icon {
	position: absolute;
	top: 5px;
	right: 5px;
	z-index: 2;
}

.stream-view {
	position: relative;
	width: 100%;
	max-width: 100%;
	overflow: hidden;
	height: 125px;
	border: 1px solid var(--v-primary-base);
	margin: auto;

	.random-text {
		position: absolute;
		width: 90%;
		bottom: 8px;
		left: 5%;
	}

	#stickerImage,
	#stickerddr {
		position: absolute;
		top: 60%;
		left: 35%;
		transform: translate(-50%, -50%) rotate(0deg) scaleX(1);

		.flip-panel-icon {
			position: absolute;
			bottom: -28px;
			left: 38%;
		}

		.flip-panel-icon:hover,
		.flip-mobile-icon:hover {
			cursor: pointer;
		}

		.icons {
			position: absolute;

			.rotate-icon {
				position: absolute;
				top: -28px;
				right: -10px;
			}

			.flip-mobile-icon {
				position: absolute;
				bottom: -28px;
				left: 38%;
			}

			.flip-panel-icon:hover,
			.flip-mobile-icon:hover {
				cursor: pointer;
			}
		}

		#sticker {
			position: relative;

			.rotate-icon {
				position: absolute;
				top: -28px;
				right: -10px;
			}

			.flip-mobile-icon {
				position: absolute;
				bottom: -28px;
				left: 38%;
			}
		}
	}
}

.loading-overlay {
	position: absolute;
	left: 0;
	top: 0;
	width: 100%;
	height: 100%;
	z-index: 2;
	background: black;
}

#normalImage {
	width: auto;
	height: auto;
	max-width: 100%;
	max-height: 100%;
}

.sticker_border {
	border: 3px dotted white !important;
	background: rgba(255, 255, 255, 0.3) !important;
	border-radius: 10px !important;
	padding: 1px;
}

#stickerddr:hover {
	cursor: all-scroll !important;
}

.drr::before {
	border: none !important;
	outline: none !important;
}

.drr.inactive,
.drr.inactive,
.ddr.disabled-ddr,
.drr.active,
.drr {
	border: 3px dotted white !important;
	border-radius: 10px !important;
	padding: 1px !important;
}

.drr.disabled-ddr {
	border: none !important;
}

.slap-btn {
	width: 100% !important;
}
</style>
